export default __webpack_public_path__ + "static/mongo-65e23bd6b97176228fdd513fdbc3fdb0.png";